import { Box, CircularProgress } from "@mui/material";

interface Props {
  sx?: { [key: string]: string };
}

const Loading = ({ sx }: Props) => {
  return (
    <Box
      style={sx}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "150px",
      }}
    >
      <CircularProgress size={80} sx={{ color: "#005eb8" }} />
    </Box>
  );
};

export default Loading;
